import classNames from 'classnames';
import { createElement } from 'react';
import './index.scss';
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["SUCCESS"] = "success";
    StatusEnum["ERROR"] = "error";
    StatusEnum["INFO"] = "info";
    StatusEnum["WAITING"] = "waiting";
    StatusEnum["WARNING"] = "warning";
})(StatusEnum || (StatusEnum = {}));
const ColorfulResult = function ColorfulResult({ status, title, description, icon, ...props }) {
    const prefixCls = 'au-result';
    const classNameList = classNames(prefixCls, {
        [`${prefixCls}-${status}`]: !!status,
    });
    return (createElement("div", { ...props, className: classNameList },
        createElement("div", { className: `${prefixCls}-icon` },
            !!icon && icon,
            status === StatusEnum.SUCCESS && !icon && createElement("i", { className: "icon-solid-check-circle" }),
            status === StatusEnum.ERROR && !icon && createElement("i", { className: "icon-solid-times-circle" }),
            status === StatusEnum.INFO && !icon && createElement("i", { className: "icon-solid-info-circle" }),
            status === StatusEnum.WARNING && !icon && createElement("i", { className: "icon-solid-exclamation-circle" }),
            status === StatusEnum.WAITING && !icon && createElement("i", { className: "icon-solid-clock" })),
        createElement("div", { className: `${prefixCls}-title` }, title),
        createElement("div", { className: `${prefixCls}-description` }, description)));
};
ColorfulResult.displayName = 'ColorfulResult';
export default ColorfulResult;
